import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BrowserModule,
  BrowserTransferStateModule
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { provideDefaultConfig, BadRequestHandler } from '@spartacus/core';
import { ProductImageZoomComponentsModule } from '@spartacus/product/image-zoom/components';
import {
  AnonymousConsentManagementBannerModule, OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  ProductFacetService,
  SearchBoxComponentService
} from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutConfigModule } from './layout/layout-config';
import { EkSearchBoxComponentService } from './services/global-search.service';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { EKProductFacetService } from './services/product-facet.service';
import { ekOccCartConfig } from './spartacus/commonComponents/cart/cart-occ.config';
import { EkCartModule } from './spartacus/commonComponents/cart/cart.module';
import { MiniEkcartModule } from './spartacus/commonComponents/cart/mini-ekcart/mini-ekcart.module';
import { CheckoutOrderSummaryModule } from './spartacus/commonComponents/checkout/checkout-order-summary/checkout-order-summary.module';
import { CheckoutModule } from './spartacus/commonComponents/checkout/checkout.module';
import { HeaderModule } from './spartacus/commonComponents/header/header.module';
import { LoginFormModule } from './spartacus/commonComponents/login-form/login-form.module';
import { OrderConfirmationModule } from './spartacus/commonComponents/order-confirmation/order-confirmation/order-confirmation.module';
import { EkdefaultViewConfig } from './spartacus/commonComponents/product/config/default-view.config';
import { ProductCardInformationModule } from './spartacus/commonComponents/product/product-card-information/product-card-information.module';
import { ProductEkItemListModule } from './spartacus/commonComponents/product/product-ekitem-list/product-ekitem-list.module';
import { EkSearchBoxModule } from './spartacus/commonComponents/search-box/ek-search-box.module';
import { UserManagementModule } from './spartacus/commonComponents/user-management/user-management.module';
import { AddEkWishListModule } from './spartacus/commonComponents/wish-list/add-ek-wishlist/add-ek-wishlist.module';
import { WishEkListModule } from './spartacus/commonComponents/wish-list/wish-eklist/wish-eklist.module';
import { AddressBookModule } from './spartacus/customComponents/address-book/address-book.module';
import { OrderModule } from './spartacus/customComponents/order/order.module';
import { AsmFeatureModule } from './spartacus/features/asm/asm-feature.module';
import { ClaimsModule } from './spartacus/features/claims/claims.module';
import { MyCompanyModule } from './spartacus/features/my-company/my-company.module';
import { PersonalDetailsModule } from './spartacus/features/personal-details/personal-details.module';
import { SpartacusModule } from './spartacus/spartacus.module';
import { EkBadRequestHandler } from './services/EkBadRequestHandler';
import { WishlistIconModule } from './ekwishlisticon/ekwishlisticon.module';








@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    BrowserTransferStateModule,
    LoginFormModule,
    ClaimsModule,
    PersonalDetailsModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    LayoutConfigModule,
    HeaderModule,
    BsDatepickerModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    EkCartModule,
    CheckoutModule,
    CheckoutOrderSummaryModule,
    OrderConfirmationModule,
    OrderModule,
    UserManagementModule,
    ProductCardInformationModule,
    AddEkWishListModule,
    ProductEkItemListModule,
    MiniEkcartModule,
    ProductImageZoomComponentsModule,
    WishEkListModule,
    AddressBookModule,
    EkSearchBoxModule,
    AsmFeatureModule,
    MyCompanyModule,
    AnonymousConsentManagementBannerModule,
    WishlistIconModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  providers: [
    provideDefaultConfig(ekOccCartConfig),
    provideDefaultConfig(EkdefaultViewConfig),
    {
      provide: SearchBoxComponentService,
      useExisting: EkSearchBoxComponentService,
    },
    {
      provide: BadRequestHandler,
      useExisting: EkBadRequestHandler,
    },
    provideDefaultConfig(),
    {
      provide: ProductFacetService,
      useExisting: EKProductFacetService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
  ],
})
@Injectable()
export class AppModule { }
